import Home from './components/Home';
import Contact from './components/Contact';
import Products from './components/Products';
import ContactList from './components/admin/ContactList';
import AdminLogin from './components/admin/Login';
import PageNotFound from './components/PageNotFound';
import PaymentSuccess from './components/PaymentSuccess';
import Resources from './components/Resources';

export const routes = [
	{path: '/', component: Home, name: 'Home'},
	{path: '/book/:id', component: Products, name: 'Products'},
	{path: '/joinus', component: Contact, name: 'Contact'},
	{path: '/admin/login', component: AdminLogin, name: 'AdminLogin'},
	{path: '/admin', component: ContactList, name: 'ContactList', meta: { requiresAuth: true }},
	{path: '/404', component: PageNotFound, name: 'PageNotFound'},
	{path: '/paymentsuccess', component: PaymentSuccess, name: 'PaymentSuccess'},
	{path: '/resources', component: Resources, name: 'Resources'},
	{path: "*", redirect: '/404'}
];